import React, { useEffect, useState } from "react"
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, Row } from "reactstrap"
import { useResponse } from "../../../../hooks/useResponse"
import { sendInvoicesEmail } from "../../../../api/invoices"
import SearchSelectBox from "../../../../components/SearchSelectBox"
import { getContacts } from "../../../../api/contact"
import ReactSelect from "react-select"
import { languageTempletsOptions } from "../../../../utils/langTemplets"

const SendInvoicesMailModal = ({handleClose, isOpen, invoices, onSucess}) => {
  const [msg, setMsg] = useState(null)
  const [template, setTemplate] = useState(null)

  const [uniqueCompanies, setUniqueCompanies] = useState([]);
  const [finalInvoices, setFinalInvoices] = useState([]);
  
  useEffect(() => {
    const invoicesByCompany = {};
    const companies = []

    invoices.forEach(invoice => {
      const companyId = invoice.contract.company.id;
      const company = invoice.contract.company;

      if (!invoicesByCompany[companyId]) {
        invoicesByCompany[companyId] = { companyId, contactId: null, invoicesIds: [] };
        companies.push(company)
      }

      invoicesByCompany[companyId].invoicesIds.push(invoice.id);
    });

    setFinalInvoices(Object.values(invoicesByCompany));
    setUniqueCompanies(companies)
  }, [invoices]);

  // no
  const {loading, error, setData} = useResponse(sendInvoicesEmail, () => {
    handleClose()
    onSucess()
    setMsg("")
    setTemplate(null)
    setFinalInvoices([])
  })
  function handleSendEmail(){
    const data = {msg, emails: finalInvoices, templateKey: template?.value || null}
    setData({type: "add", data})
  }

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered={true}>
      <ModalBody className="py-5 px-5">
      <h2 className="text-center mb-4">Send Via Email</h2>
        
        <Row className="mb-3">
          <Col md={12}>
            <FormGroup>
                <Label>Message:</Label>
                <Input type="text" placeholder="write a message" value={msg} onChange={(e) => setMsg(e.target.value)} />
            </FormGroup>
          </Col>

          <Col md={12}>
            <FormGroup className="">
                <Label>Template:</Label>
                <ReactSelect
                  options={languageTempletsOptions}
                  value={template}
                  onChange={(op) => setTemplate(op)}
                  isSearchable={false}
                  isClearable={true}
                />
            </FormGroup>
          </Col>
        </Row>

        {
          uniqueCompanies.map((company, idx) => {
            return (
              <Row key={company.id} className="mb-3">
                <Col md={5}>
                  <FormGroup className="d-flex flex-column">
                      <Label className="">Company #{idx+1}:</Label>
                      <span>Name: {company?.name}</span>
                      <span>Invoices Number: {finalInvoices.find(inv => inv.companyId == company.id)?.invoicesIds.length}</span>
                  </FormGroup>
                </Col>

                <Col md={7}>
                  <FormGroup className="">
                    <Label>Contact #{idx+1}:</Label>
                    <SearchSelectBox
                        type="company_contacts"
                        label='email'
                        api={getContacts}
                        apiMeta={{companyId: company?.id}}
                        value={finalInvoices[idx]?.contactId || null}
                        setValue={e => {
                          setFinalInvoices(prev => {
                            return prev.map((inv, i) => {
                              if(idx === i) {
                                return {...inv, contactId: e?.id}
                              } else {
                                return inv
                              }
                            })
                          })
                        }}
                    /> 
                  </FormGroup>
                </Col>
              </Row>
            )
          })
        }
          
       
        <div className="mt-4 d-flex gap-4 align-items-center justify-content-center">
          <Button
            onClick={handleSendEmail}
            color="primary"
            size="lg"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send"}
          </Button>
          <Button onClick={handleClose} color="dark" size="lg">
            Cancel
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default SendInvoicesMailModal
